import { Suspense } from "react";
import { PageNodes as Elements, type PageNodesProps } from "./page-nodes";
import { AbilityReference, LiveMatchup, LiveMatchupControl } from "./league/lazy-widgets";

/** Native widgets stay in the Start runtime; the authored-element renderer is shared with Customize. */
export function PageNodes(props: PageNodesProps) {
  return (
    <Elements
      {...props}
      renderServerNode={(node, attributes, context) => {
        if (props.renderServerNode) return props.renderServerNode(node, attributes, context);
        if (node.kind === "abilityReference")
          return (
            <Suspense key={node.id}>
              <AbilityReference
                node={node}
                attributes={attributes}
                portraits={context.bindings.abilityPortraits?.[node.id]}
                roles={context.bindings.abilityRoles?.[node.id]}
              />
            </Suspense>
          );
        if (node.kind === "liveMatchupControl")
          return (
            <Suspense key={node.id}>
              <LiveMatchupControl node={node} attributes={attributes} />
            </Suspense>
          );
        if (node.kind === "liveMatchup")
          return (
            <Suspense key={node.id}>
              <LiveMatchup
                node={node}
                attributes={attributes}
                signedIn={!!context.member}
                guideHref={(slug) => {
                  const path = `/matchups/${slug}`;
                  return context.linkTo
                    ? context.linkTo(path)
                    : `${path}${context.preview ? "?preview=1" : ""}`;
                }}
              >
                <Elements {...context} nodes={node.children} section={context.section ?? node.id} />
              </LiveMatchup>
            </Suspense>
          );
        return undefined;
      }}
    />
  );
}
